export default "__VITE_ASSET__p9M1zGIw__"